import React from 'react';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/footer/Footer';
import AboutCarousel from './sections/AboutCarousel';
import AboutGeneral from './sections/AboutGeneral';
import AboutStaff from './sections/AboutStaff';
import './aboutus.css';

function Aboutus() {
  return (
    <>
      
      <div className='AboutUs'>  
        <div className="aboutus__background__container">
          <Navbar />
          <div className="nav-overlay"></div>
          <AboutCarousel />
          <AboutGeneral />
          <AboutStaff />
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Aboutus;